import getConfig from 'config/public'

// Given a url from bxapi with a harcoded domain generate a url for the current environment
export const updateBaseUrl = rawUrl => rawUrl.replace('https://www.getapp.com', getConfig().baseUrl)
